"use client";

import {useEffect, useState} from "react";
import {createPracticeSession, getRepertoire} from "@/lib/api";
import { useRouter } from "next/navigation";
import {RepertoireEntry} from "@/types/repertoire";
import {PracticeSession} from "@/types/practice-session";

export function PracticeSessionForm() {
    const router = useRouter();
    const [pieces, setPieces] = useState<RepertoireEntry[]>([]);

    const [formData, setFormData] = useState<PracticeSession>({
        date: "",
        minutes: 10,
        repertoire_id: 0,
        reflection: "",
    });

    useEffect(() => {
        getRepertoire().then(setPieces).catch(console.error);
    }, []);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]:
                name === "minutes" || name === "repertoire_id"
                    ? Number(value)
                    : value,
        });
    };

    async function handleSubmit(e: React.SyntheticEvent) {
        e.preventDefault();

        await createPracticeSession(formData);

        router.push("/practice-sessions");
        router.refresh();
    }

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <input
                type="date"
                name="date"
                className="w-full rounded-xl border p-3"
                value={formData.date}
                onChange={handleChange}
            />

            <input
                name={"minutes"}
                className="w-full rounded-xl border p-3"
                type="number"
                value={formData.minutes}
                onChange={handleChange}
            />

            <select
                className="w-full rounded-xl border p-3"
                name="repertoire_id"
                value={formData.repertoire_id}
                onChange={handleChange}
            >
                <option value={0}>Select piece</option>

                {pieces.map((piece) => (
                    <option key={piece.id} value={piece.id}>
                        {piece.work?.title ?? "Unknown work"}
                    </option>
                ))}
            </select>

            <input
                name="reflection"
                className="w-full rounded-xl border p-3"
                placeholder="Reflection"
                value={formData.reflection}
                onChange={handleChange}
            />

            <button
                type="submit"
                className="rounded-xl border px-4 py-2"
            >
                Add Session
            </button>
        </form>
    );
}